<template>
  <div>
    <RegistrationSummaryGroup
      :label="$t('dbc-label-payment-method')"
      :value="paymentMethodLabel"
    />
    <RegistrationSummaryGroup
      :label="$t('dbc-label-card-type')"
      :value="paymentResult?.attributes.brand"
      v-if="paymentMethod === 'creditcard'"
    />
    <RegistrationSummaryGroup
      :label="$t('dbc-label-payment-credit-card-number')"
      :value="paymentResult?.attributes?.cardNumber?.replace(/\*/g, '•')"
      v-if="paymentMethod === 'creditcard'"
    />
    <RegistrationSummaryGroup
      :label="$t('dbc-payment-date-of-expiry')"
      :value="
        paymentResult?.attributes.expiryMonth +
        '/' +
        paymentResult?.attributes.expiryYear
      "
      v-if="paymentMethod === 'creditcard'"
    />
    <RegistrationSummaryGroup
      :label="$t('dbc-payment-check-number')"
      value="•••"
      v-if="paymentMethod === 'creditcard'"
    />
    <RegistrationSummaryGroup
      :label="$t('dbc-payment-account-holder')"
      :value="paymentResult?.attributes.accountHolder"
      v-if="paymentMethod === 'sepa'"
    />
    <RegistrationSummaryGroup
      label="IBAN"
      :value="paymentResult?.attributes.iban"
      v-if="paymentMethod === 'sepa'"
    />
    <RegistrationSummaryGroup
      label="BIC"
      :value="paymentResult?.attributes.bic"
      v-if="paymentMethod === 'sepa' && paymentResult?.attributes.bic != null"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  paymentResult?: PaymentData | null
}>()

const { t } = useI18n()

const paymentMethod = useState('dbc-payment-method')
const paymentMethodLabel =
  paymentMethod.value === 'creditcard'
    ? t('dbc-label-creditcard')
    : t('dbc-label-sepa')
</script>
